import React, { FC } from 'react';
import { SVGTooltipProps } from '@utils';
import { SvgWithTooltip } from "./SvgWithTooltip";

export const HolidayIcon: FC<SVGTooltipProps> = ({ onClick, divClassName, tooltip }) => (
  <SvgWithTooltip
    onClick={onClick}
    divClassName={divClassName}
    tooltip={tooltip}
  >
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2911_40704)">
        <path d="M1.5 16.5L12 12.75L5.25 6L1.5 16.5ZM9.2625 12.135L3.975 14.025L5.865 8.7375L9.2625 12.135Z" fill="#FF9C40"/>
        <path d="M10.8975 9.39602L15.09 5.20352C15.4575 4.83602 16.05 4.83602 16.4175 5.20352L16.86 5.64602L17.655 4.85102L17.2125 4.40852C16.41 3.60602 15.0975 3.60602 14.295 4.40852L10.1025 8.60102L10.8975 9.39602Z" fill="#FF9C40"/>
        <path d="M7.54504 5.15875L7.10254 5.60125L7.89754 6.39625L8.34004 5.95375C9.14254 5.15125 9.14254 3.83875 8.34004 3.03625L7.89754 2.59375L7.10254 3.39625L7.54504 3.83875C7.90504 4.19875 7.90504 4.79875 7.54504 5.15875Z" fill="#FF9C40"/>
        <path d="M12.795 8.90852L11.6025 10.101L12.3975 10.896L13.59 9.70352C13.9575 9.33602 14.55 9.33602 14.9175 9.70352L16.125 10.911L16.92 10.116L15.7125 8.90852C14.9025 8.10602 13.5975 8.10602 12.795 8.90852Z" fill="#FF9C40"/>
        <path d="M11.295 4.40875L8.60254 7.10125L9.39754 7.89625L12.09 5.20375C12.8925 4.40125 12.8925 3.08875 12.09 2.28625L10.8975 1.09375L10.1025 1.88875L11.295 3.08125C11.655 3.44875 11.655 4.04875 11.295 4.40875Z" fill="#FF9C40"/>
      </g>
      <defs>
        <clipPath id="clip0_2911_40704">
          <rect width="18" height="18" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  </SvgWithTooltip>
);
